module.exports = __webpack_public_path__ + "static/img/img3.77cb43c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ychy/img3.png
// module id = 7ASG
// module chunks = 1